export default __webpack_public_path__ + "static/media/1248.4d2c5762.png";